import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import debounce from 'lodash/debounce';
import flowRight from 'lodash/flowRight';
import TEXT from '../../../text';
import * as FILTER_HELPER from '../../../utils/filterHelperFunctions';

class NameFilter extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { name: '' };
    this.onChangeDebounced = flowRight(
      debounce(this.onChangeDebounced, 400),
      e => e.persist() || e
    );
  }

  componentDidUpdate(prevProps) {
    if (this.props.name !== prevProps.name) {
      this.setState({ name: this.props.name }); // eslint-disable-line
    }
  }

  /**
   * OnChange method for the StarRating component, calls the onFilterChange function
   * @param  {number} value number of selected newSetFilterParameters
   */
  onChangeDebounced = event => {
    this.props.onFilterChange(
      'name',
      event.target.value,
      FILTER_HELPER.filterFunctions.name
    );
  };

  onChange = event => {
    this.setState({ name: event.target.value });
    this.onChangeDebounced(event);
  };

  render() {
    return (
      <div className="col-12">
        <TextField
          id="standard-search"
          label={TEXT.filter.mainFilter.name}
          type="search"
          margin="normal"
          onChange={this.onChange}
          value={this.state.name}
        />
      </div>
    );
  }
}
NameFilter.defaultProps = {};
NameFilter.propTypes = {
  onFilterChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired
};
export default NameFilter;
